import React, { useState, useEffect } from "react";
import { NavLink } from "react-router-dom";
// Chargement
import Loader from "./loader.js";
// Déco
import { ReactComponent as Deco } from '../assets/deco-svg.svg';
// Offcanvas
import Offcanvas from "./offcanvas.js";

// Connexion à la BDD
import { collection, getDocs } from "firebase/firestore";
import { db } from "../firebase.js";

// Import de la fonction de retour d'image
import ReturnImage from "../functions/image.js";

const About = () => {

    const [aboutList, setAboutList] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [items, setItems] = useState([]);

    const collectionName = "about";
            
    async function getAboutEvents(event) {
        let allEvents = [];
        try {
            const querySnapshot = await getDocs(collection(db, collectionName));    

            querySnapshot.forEach((doc) => {
                let aboutEvent = doc.data();
                aboutEvent.id = doc.id;
                allEvents.push(aboutEvent);
            });
        } catch (error) {
            console.error("Erreur lors de la lecture des données:", error);
        }

        return allEvents;
    }

    useEffect(() => {        
        let tab = [];
        getAboutEvents()
        .then(events => {
            events.forEach(e => {
                tab.push(e);
                setItems((prevItems) => [...prevItems, false]);
            });
            setIsLoading(false);
        })
        .catch(error => {
            console.error("Erreur lors de la récupération des données:", error);
            setIsLoading(true);
        });
        
        setAboutList(tab);
    }, []);

    useEffect(() => {
        const offcanvas = document.querySelector('.mek-offcanvas');
        if (offcanvas) {
            document.querySelector(".mek-offcanvas-close").addEventListener("click", () => {

                setTimeout(() => {
                    if (offcanvas.dataset.active == "false") {
                        setItems(prevItems => {
                            const newItems = [...prevItems];
                            newItems[offcanvas.id] = false;
                            return newItems;
                        });
                    }
                }, 50);
            });
        }
    }, [items]);

    return(
        <div className="container-fluid about" id="about">
            {isLoading && (
                <Loader />
            )}
            <div className="row text-white">
                {aboutList.map((item, index) => (
                    <div className={`col-12 ${index !== 0 && ' col-sm-6'} col-lg-4 about-section pt-2 pb-2 pt-sm-4 pb-sm-4 pt-lg-5 pb-lg-5 px-4 px-lg-5 py-4 py-lg-5 d-flex flex-column align-items-center justify-content-center bg-responsive about-hobbies`} id={index}>
                        <h3 className="about-title text-center mt-2 mt-sm-4 mt-lg-5">{item.title}</h3>
                        <p className="about-paragraph">{item.short_desc}</p>
                        <button className="btn about-button" onClick={() => {
                            items[index] = true;
                            setItems(prevItems => {
                                const newItems = [...prevItems];
                                newItems[index] = true;
                                return newItems;
                            });
                        }} >En savoir plus</button>
                        <ReturnImage
                         imageName={item.image_src}
                         classname="about-image"
                         alt={item.alt}
                         viewport={33} />
                        {items[index] && (
                            <div>
                                <Offcanvas 
                                 title={item.detail_title} 
                                 description={item.description}
                                 images={item.images}
                                 active={items[index]}
                                 id={index} />
                            </div>
                        )}
                    </div>
                ))}
            </div>
        </div>        
    )
};

export default About;